import StateProvider from '../../configState/StateProvider';
import AssetResolver from './AssetResolver';
export default (() => {
  let assetResolver;
  let isRegistered = false;

  const _state = new StateProvider();

  function _saveToState(asset) {
    _state.setIn([asset.urn], {
      ...asset?.source,
      ...asset,
    });
  }

  /*
   *
   * Service Functions:
   *
   */

  // Initialization

  const register = (connectionProvider) => {
    isRegistered = true;
    assetResolver = new AssetResolver(connectionProvider);
  };

  // Getters

  const getAsset = async (urn) => {
    if (!_state.get(urn)) {
      const asset = await assetResolver.learnerAssetGet(urn);
      _saveToState(asset);
    }

    const asset = _state.get(urn);
    return asset;
  };

  return {
    isRegistered: () => isRegistered,
    register,
    getAsset,
  };
})();
